<template lang="pug">
  .home
    Jumbo
    Looper(:articles="articles")

</template>

<script>
import { mapState } from 'vuex'

import Sharer from '@/components/Sharer'
import Jumbo from '@/components/Jumbo'
import Looper from '@/components/Looper'

export default {
  name: 'home',
  components: {
    Jumbo,
    Sharer,
    Looper
  },
  computed: mapState([
    'articles',
    'categories',
    'config'
  ])
}
</script>
